




import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DirectAccessError extends Vue {}
